module.exports = __webpack_public_path__ + "static/img/zhibozhongxin.d3a35d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type/daohang/zhibozhongxin.png
// module id = I1S7
// module chunks = 12